import React from 'react';
import PlaceholderPage from '../components/PlaceholderPage';

const UsageHistory = () => <PlaceholderPage title="이용 내역" description="회원별 서비스 이용 내역을 확인해요." />;

export default UsageHistory;
